import React, {useRef, useState} from 'react';

const Tooltip = ({content, children, customClass, disabled}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipRef = useRef();
    const handleMouseEnter = () => {
        setShowTooltip(!disabled && true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className="sl-relative sl-inline-flex" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}

            <div
                style={{top: `-${tooltipRef.current?.clientHeight + 10}px`}}
                ref={tooltipRef}
                className={`${customClass} sl-tooltip sl-top-0 sl-w-36 sl-flex sl-z-10 sl-flex-col sl-align-center sl-justify-center sl-translate-top-center ${showTooltip ? '' : 'sl-visibility-hidden'}`}>
                <div className="sl-rounded-lg sl-bg-white sl-shadow-sm sl-z-10 sl-py-2 sl-px-3 sl-flex sl-flex-col sl-gap-1">
                    <p className="sl-font sl-text-xs sl-font-medium sl-m-auto">
                        {content}
                    </p>
                </div>
                <span
                    className="sl-tooltip-pointer sl-z-10 sl-pointer-center sl-left-auto sl-w-3 sl-h-3 sl-bg-white sl-rounded-1 sl-absolute"/>
            </div>

        </div>
    );
};

export default Tooltip;
